import React from 'react'
import { IoMdCreate } from "react-icons/io";
function Threats() {
    const handleEdit = () => {
        
    }
  return (
    <div className="box2 mb-4">
    <div className="box-header">
        <h4 className='subtitle-font'>threats</h4>
        <IoMdCreate
            onClick={handleEdit}
            style={{
                fontSize: '20px',
                cursor: 'pointer',
            }}
        />
    </div>
   
</div>
  )
}

export default Threats